<div class="modal fade" id="wheel-dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="errorModalLabel">
                    Winner!
                </h5>

                <button id="btn-wheel-close" type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body">
                <span id="wheel-dialog-winner">Name</span> has won!
            </div>

            <div class="modal-footer">
                <button
                    id="btn-wheel-ok"
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">
                    OK
                </button>
                <button
                    id="btn-wheel-remove"
                    type="button"
                    class="btn btn-primary"
                    data-bs-dismiss="modal">
                    Remove from wheel
                </button>
            </div>

        </div>
    </div>
</div>